"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "HorizontalScroll", {
  enumerable: true,
  get: function get() {
    return _HorizontalScroll["default"];
  }
});
var _HorizontalScroll = _interopRequireDefault(require("./HorizontalScroll"));